import React from "react";
import LanguageButton from "./LanguageButton";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Brightness from "../scripts/Brightness";
import LogThis from "../scripts/LogThis";

class PreviewButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languages: this.props.languages,
      selectedLang: "En",
      selectedLangURL: "en-us"
    };
    this.updateSelectedLang = this.updateSelectedLang.bind(this);
  }

  updateSelectedLang(theLang) {
    switch (theLang) {
      case "En":
        this.setState({
          selectedLang: "En",
          selectedLangURL: "en-us"
        });
        break;

      case "És":
        this.setState({
          selectedLang: "És",
          selectedLangURL: "es-na"
        });
        break;

      case "Fr":
        this.setState({
          selectedLang: "Fr",
          selectedLangURL: "fr-eu"
        });
        break;

      default:
        break;
    }
  }

  render() {
    const ButtonBackgroundBorder = Brightness(
      this.props.themeStyles.mainColor,
      -0.2
    );
    const ButtonBackground = this.props.themeStyles.mainColor;
    const ButtonBackgroundHover = Brightness(
      this.props.themeStyles.mainColor,
      -0.2
    );
    const ButtonBackgroundActive = Brightness(
      this.props.themeStyles.mainColor,
      -0.4
    );
    const ButtonStyles = styled.a`
      background-color: ${ButtonBackground};
      border: solid 1px ${ButtonBackgroundBorder};

      &:hover {
        background-color: ${ButtonBackgroundHover};
      }

      &:active {
        background-color: ${ButtonBackgroundActive};
      }
    `;

    const LinkStyles = styled(NavLink)`
      color: white;
      text-decoration: underline;

      &:hover {
        color: ${this.props.themeStyles.mainColor};
      }
    `;
    let fontColorDimmer;

    if (this.props.popup === true) {
      fontColorDimmer = Brightness(this.props.themeStyles.fontColor, -0.6);
    } else {
      fontColorDimmer = Brightness(this.props.themeStyles.fontColor, -0.3);
    }

    const HoverLink = Brightness(this.props.themeStyles.mainColor, -0.4);

    const OtherText = styled.span`
      color: ${fontColorDimmer};

      a {
        color: ${HoverLink};
        font-weight: 500;
        text-decoration: underline;

        &:hover {
          color: ${this.props.themeStyles.mainColor};
        }
      }
    `;

    let theURL =
      "https://" +
      this.props.localURL +
      "/index.php?/" +
      this.state.selectedLangURL +
      "/" +
      this.props.courseURL;
    let languages = this.state.languages;

    if (this.props.supported === true) {
      return (
        <div className="previewButtonContainer">
          <div style={{padding: '10px 0', margin: '5px 0'}}>
          {languages.map((lang, id) => {
            let myLang;

            if (languages.length > 1) {
              switch (lang) {
                case "English":
                  myLang = "En";
                  break;

                case "Spanish":
                  myLang = "És";
                  break;

                case "French":
                  myLang = "Fr";
                  break;

                default:
                  break;
              }

              return (
                <LanguageButton
                  key={id}
                  activeLang={this.state.selectedLang}
                  myLang={myLang}
                  updateSelectedLang={this.updateSelectedLang}
                  themeStyles={this.props.themeStyles}
                  popup={this.props.popup}
                />
              );
            } else {
              return null;
            }
          })}
          </div>
          <ButtonStyles
            className="previewButton"
            onClick={() => {
              LogThis(this.props.loggedInInfo, "view", this.props.courseName);
            }}
            target="_blank"
            href={theURL}
          >
            Preview
          </ButtonStyles>
        </div>
      );
    } else {
      return (
        <div className="previewButtonContainer unsupportedContainer">
          <OtherText className="unsupported">
            To preview courses,{" "}
            <LinkStyles to="requirements">use a supported browser</LinkStyles>.
          </OtherText>
        </div>
      );
    }
  }
}

export default PreviewButton;
